import { useMutation, useQueryClient } from "react-query";
import { updatePaymentRemittanceType } from "../../../../../actions/Utilities/PaymentRemittanceType";
import { PaymentRemittanceTypeInfo } from "../types";
import { toast } from "../../../../../components/toastNotification";

const useUpdatePaymentRemittanceType = () => {
  const queryClient = useQueryClient();
  const { mutate } = useMutation(
    (newData: PaymentRemittanceTypeInfo) =>
      updatePaymentRemittanceType(newData),
    {
      onSuccess: (res: any) => {
        if (res.data === "Duplicate") {
          toast.fire("Saving Failed", "The data already exists!", "error");
        } else {
          queryClient.invalidateQueries(["GetLicenseType"]);
          toast.fire(
            "Success",
            "Payment Remittance Type Updated Successfully",
            "success"
          );
        }
      },
      onError: (error) => {
        toast.fire(
          "Failed",
          "Failed to Update Payment Remittance Type!",
          "error"
        );
      },
    }
  );
  return mutate;
};
export default useUpdatePaymentRemittanceType;
